import React, { useEffect, useState } from 'react'
import { notify } from '@/_helpers'
import { API, NoContentBox } from '@enkla-gui'

const getParam = name => {
  const fromSearch = new URLSearchParams(window.location.search).get(name)
  if (fromSearch) return fromSearch
  const hash = window.location.hash
  const queryIndex = hash.indexOf('?')
  if (queryIndex !== -1) return new URLSearchParams(hash.slice(queryIndex + 1)).get(name)
  return null
}

export default function BokioIntegrationCallback() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    API.post('api/bokio/authenticate', {
      state: getParam('state'),
      code: getParam('code')
    })
      .then(res => {
        notify.toast('Integration kopplad')
        setLoading(false)
        window.location.hash = '#!/integration/overview'
      })
      .catch(([err, res]) => {
        notify.toast(res, 'error')
        setLoading(false)
        setError(true)
      })
  }, [])

  return (
    <div className='container-absolute-center'>
      {loading && <NoContentBox text='Integrerar...' icon='fa-circle-notch fa-spin' />}
      {error && <NoContentBox text='Något gick fel. Vänligen försök igen.' icon='fa-exclamation-triangle' />}
      {!loading && !error && <NoContentBox text='Integration kopplad!' icon='fa-thumbs-up' />}
    </div>
  )
}
